module.exports = __webpack_public_path__ + "static/media/UCLAlogo.b20b5674.png";